module.exports = __webpack_public_path__ + "img/cinna.b7a074fa.jpg";